import { Link } from "@tanstack/react-router";
import { MessagesSquare } from "lucide-react";

import { CockpitConversation } from "@/components/cockpit/cockpit-conversation";
import { Button } from "@/components/ui/button";
import type { PersonDetail } from "@/api/db/people";

export function FichaConversation({ person }: { person: PersonDetail }) {
	return (
		<div className="flex flex-col gap-3">
			<Button asChild variant="outline" size="sm" className="self-end">
				<Link to="/conversas" search={{ person: person.id }}>
					<MessagesSquare />
					Abrir em conversas
				</Link>
			</Button>
			<div className="h-[75dvh] min-h-96 overflow-hidden workspace-frame">
				<CockpitConversation personId={person.id} />
			</div>
		</div>
	);
}
